import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import { alert } from "./alert.module";
import { auth } from "./auth.module";
import { category } from "./category.module";
import { filter } from "./filter.module";
import { map } from "./map.module";
import { search } from "./search.module";
import { notifications } from "./notifications.module";
import favorite from "./modules/favorite.module";
import favoriteList from "./modules/favoriteList";
import personalProfile from "./modules/personalProfile.module";
import companyProfile from "./modules/companyProfile.module";
import profile  from "./modules/job-seeker-profile.module";

// Import the new module
import NewCategory from "@/store/modules/NewCategory"; 
import breadcrumbs from "@/store/modules/breadcrumbs"; // Import the Breadcrumbs 
import FilterStore from '@/store/modules/FilterStore';
import savedSearches from '@/store/modules/savedSearches';
import PropertyFilterStore from '@/store/modules/PropertyFilterStore';
import candidate from './modules/candidate.module'
import jobs from './modules/jobs.module'
import allListings from "./modules/allListings.module";
import amenities from '@/store/modules/AmenityStore';
import RecentlyViewedStore from './modules/RecentlyViewedStore'; // Add this import
import theme from './modules/theme';
import font from './modules/font'; 
import userListings from './modules/userListings';
import homeListings from './modules/HomeListingsStore'



export default createStore({
  plugins: [createPersistedState()],
  state: {
    isAuthenticated: false,
    inactivityTimeout: null,
  },

  mutations: {
    login(state) {
      state.isAuthenticated = true;
    },

    logout(state) {
      state.isAuthenticated = false;
    },

    setInactivityTimeout(state, timeout) {
      state.inactivityTimeout = timeout;
    },

    clearUser(state) {
      state.isAuthenticated = false;
    },
  },

  actions: {
    startInactivityTimeout({ commit, dispatch }) {
      const timeout = setTimeout(() => {
        dispatch("auth/logout");
        commit("setInactivityTimeout", null);
      }, 1 * 60 * 1000);

      commit("setInactivityTimeout", timeout);
    },

    resetInactivityTimeout({ state, dispatch }) {
      if (state.inactivityTimeout) {
        clearTimeout(state.inactivityTimeout);
      }
      dispatch("startInactivityTimeout");
    },

    clearUserData({ commit }) {
      localStorage.removeItem("user");
      commit("clearUser");
    },
  },

  // Modules
  modules: {
    auth,
    notifications,
    favorite,
    favoriteList,
    personalProfile,
    companyProfile,
    candidate,
    profile, // Job Seeker Profile
    allListings, // Register the allListings module
    jobs,
    alert,
    category,
    filter,
    map,
    search,
    NewCategory,
    breadcrumbs,
    FilterStore, // Register the FilterStore module
    savedSearches, // Register the savedSearches module
    propertyFilter: PropertyFilterStore, // ✅ Register the PropertyFilterStore module
    amenities,
    recentlyViewed: RecentlyViewedStore,
    theme,
    font,
    userListings,
    homeListings
  }
})
